// A price per small unit (LF, BF, PCS) is often under a dollar, where cents hide real
// differences between sellers, so it keeps 4 decimals there.
export const UNIT_PRICE_MAX_DECIMALS = 4;
export const unitPriceMaxDecimals = (amount: number) =>
  Math.abs(amount) < 1 ? UNIT_PRICE_MAX_DECIMALS : 2;

// A number input sends '' for text it cannot parse.
export const unitPriceMaxDecimalsForInput = (
  value: string,
  rowPrice: number | null
) => {
  const typed = Number(value);
  return unitPriceMaxDecimals(value.trim() !== '' ? typed : (rowPrice ?? 1));
};

// Cleans binary noise before rounding so half-cent prices round as the Intl display does.
export function roundUnitPrice(amount: number): number {
  const factor = 10 ** unitPriceMaxDecimals(amount);
  return Math.round(Number((amount * factor).toPrecision(15))) / factor;
}
